import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {formatTableParams} from 'utils/index'
import {getPostStatList} from '../service'

const model = createProjectModel({
    projectNamespace: 'post-stat',
    state: {
        tableData: {},
    },
    effects: {
        *getTableList({payload}, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            params.id = payload.id

            const res = yield call(getPostStatList, params)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },
    },
})

export default model
